<script setup lang="ts">
import { UiButton, UiIcon, UiSelect, UiText } from "@shopexperts/shared";
import type { SatelliteActiveFilter } from "@/app/composables/satellite-contact-sites/useSatelliteSitesPage";

const searchInput = defineModel<string>("searchInput", { required: true });
const activeFilter = defineModel<SatelliteActiveFilter>("activeFilter", { required: true });

defineEmits<{
    (e: "create"): void;
}>();

const filterOptions: readonly { label: string; value: SatelliteActiveFilter }[] = [
    { label: "All sites", value: "all" },
    { label: "Active only", value: "active" },
    { label: "Inactive only", value: "inactive" },
];
</script>

<template>
    <div class="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
        <div class="flex flex-col gap-1 max-w-2xl">
            <h1 class="text-3xl font-normal">Satellite Contact Sites</h1>
            <UiText
                as="p"
                variant="p"
                class="text-se-gray-600"
                text="Register partner websites that submit contact leads through Shopexperts. Each site gets an access key for authenticated API calls."
            />
        </div>

        <div class="flex flex-wrap items-center gap-3">
            <div class="w-[180px]">
                <UiSelect
                    v-model="activeFilter"
                    :options="(filterOptions as unknown as Array<{ label: string; value: string }>)"
                    placeholder="All sites"
                    size="md"
                />
            </div>

            <div class="relative w-[260px]">
                <div class="absolute left-3 top-1/2 -translate-y-1/2">
                    <UiIcon name="search" class="w-5 h-5 text-se-gray-500" />
                </div>
                <input
                    v-model="searchInput"
                    type="text"
                    placeholder="Search by name or URL..."
                    class="w-full h-9 pl-10 pr-3 py-1 border border-se-gray-300 rounded bg-white text-sm focus:outline-none focus:ring-2 focus:ring-se-primary"
                />
            </div>

            <UiButton variant="primary" label="Add Satellite Site" @click="$emit('create')">
                <template #before_label>
                    <UiIcon name="plus-square" class="w-5 h-5 text-se-primary" />
                </template>
            </UiButton>
        </div>
    </div>
</template>
